// extracted by mini-css-extract-plugin
export var dosCredit = "DosCredit-module--dos-credit--2SgUk";
export var dosCreditText = "DosCredit-module--dos-credit-text--3fg3C";